import ROUTER from './ROUTER'

// tabid khớp codeKey thật từ GetListTab (= p_category.Identity, xem RoleService.GetListTab).
// Gate ở CẤP LEAF, KHÔNG gate ở cấp nhóm cha: AdminRoutes/index.tsx dùng
// setShowListMenu(ADMIN_MENU_CONFIG, listTab).length > 0 để quyết định cho vào hay chặn 403
// TOÀN BỘ app. Nếu 1 nhóm cha tự mang tabid riêng, user thiếu đúng quyền đó sẽ bị lọc mất cả
// nhóm (kể cả các leaf con không cần tabid) — đây là bug cũ (chỉ có nhóm "Quản trị hệ thống"
// yêu cầu Settings.Role.View, nên mọi tài khoản không phải admin bị 403 toàn app).
// Leaf không có tabid (vd QUAN_LY_DANH_MUC_CHUC_NANG) = luôn hiện, hasPermission() trả true khi
// tabid rỗng/undefined.
export const ADMIN_MENU_CONFIG = [
  {
    key: 'group-Dashboards',
    label: 'Tổng quan',
    icon: 'LayoutDashboard',
    tabid: ['DashboardAdmin'],
    children: [
      {
        key: ROUTER.THONG_KE_TONG_QUAN,
        label: 'Bảng thông tin',
        tabid: ['DashboardAdmin'],
      },
    ],
  },
  {
    key: 'group-Categories',
    label: 'Danh mục dùng chung',
    icon: 'Layers',
    tabid: ['BusinessField', 'Province', 'District', 'Ward', 'Unit', 'Organization'],
    children: [
      {
        key: ROUTER.LINH_VUC_HOAT_DONG,
        label: 'Lĩnh vực hoạt động',
        tabid: ['BusinessField'],
      },
      {
        key: ROUTER.TINH_THANH,
        label: 'Tỉnh/Thành phố',
        tabid: ['Province'],
      },
      {
        key: ROUTER.QUAN_HUYEN,
        label: 'Quận/Huyện',
        tabid: ['District'],
      },
      {
        key: ROUTER.XA_PHUONG,
        label: 'Xã/Phường',
        tabid: ['Ward'],
      },
      {
        key: ROUTER.DON_VI_DO_LUONG,
        label: 'Đơn vị đo lường',
        tabid: ['Unit'],
      },
      {
        key: ROUTER.DON_VI_QUAN_LY,
        label: 'Đơn vị quản lý',
        tabid: ['Organization'],
      },
    ],
  },
  {
    key: 'group-Goods',
    label: 'Sản phẩm',
    icon: 'Tag',
    tabid: [
      'ProductCategory',
      'Product',
      'ProductRegister',
      'ProductPromotionRegister',
      'ProductOcop',
      'ProductOcopRegister',
      'ProductEvaluationDossier',
    ],
    children: [
      {
        key: ROUTER.DANH_MUC_SAN_PHAM,
        label: 'Loại sản phẩm',
        tabid: ['ProductCategory'],
      },
      {
        key: ROUTER.PRODUCT,
        label: 'Sản phẩm',
        tabid: ['Product'],
      },
      {
        key: ROUTER.DANG_KY_SAN_PHAM,
        label: 'Đăng ký sản phẩm',
        tabid: ['ProductRegister'],
      },
      {
        key: ROUTER.DANG_KY_KHUYEN_MAI,
        label: 'Đăng ký khuyến mại',
        tabid: ['ProductPromotionRegister'],
      },
      {
        key: ROUTER.PRODUCT_OCOP,
        label: 'Sản phẩm OCOP',
        tabid: ['ProductOcop'],
      },
      {
        key: ROUTER.PRODUCT_OCOP_REGISTER,
        label: 'Đăng ký sản phẩm OCOP',
        tabid: ['ProductOcopRegister'],
      },
      {
        key: ROUTER.PRODUCT_PROMOTION,
        label: 'Khuyến mãi',
        tabid: ['ProductPromotionRegister'],
      },
      {
        key: ROUTER.PRODUCT_EVALUATION_DOSSIER,
        label: 'Quản lý hồ sơ đánh giá sản phẩm',
        tabid: ['ProductEvaluationDossier'],
      },
    ],
  },
  {
    key: 'group-Ecommerces',
    label: 'Thương mại điện tử',
    icon: 'BadgeDollarSign',
    tabid: ['Order', 'SupplyDemand'],
    children: [
      {
        key: ROUTER.DON_HANG,
        label: 'Quản lý thông tin đặt hàng',
        tabid: ['Order'],
      },
      {
        key: ROUTER.CUNG_CAU,
        label: 'Quản lý cung cầu',
        tabid: ['SupplyDemand'],
      },
    ],
  },
  {
    key: 'group-Enterprises',
    label: 'Quản lý hồ sơ đăng ký doanh nghiệp',
    icon: 'BriefcaseBusiness',
    tabid: ['Company', 'CompanyRegister'],
    children: [
      {
        key: ROUTER.DOANH_NGHIEP,
        label: 'Doanh nghiệp TXNG',
        tabid: ['Company'],
      },
      {
        key: ROUTER.DANG_KY_DOANH_NGHIEP,
        label: 'Hồ sơ đăng ký doanh nghiệp',
        tabid: ['CompanyRegister'],
      },
    ],
  },
  {
    key: 'group-Partners',
    label: 'Đối tác',
    icon: 'HeartHandshake',
    tabid: ['Partner', 'PartnerProcessor', 'PartnerLogistics', 'PartnerDistributor'],
    children: [
      {
        key: ROUTER.DOI_TAC_SAN_XUAT,
        label: 'Đối tác sản xuất ban đầu',
        tabid: ['Partner'],
      },
      {
        key: ROUTER.DOI_TAC_SO_CHE,
        label: 'Đối tác sơ chế - chế biến',
        tabid: ['PartnerProcessor'],
      },
      {
        key: ROUTER.DOI_TAC_KHO_VAN,
        label: 'Đối tác kho vận',
        tabid: ['PartnerLogistics'],
      },
      {
        key: ROUTER.DOI_TAC_PHAN_PHOI,
        label: 'Đối tác phân phối',
        tabid: ['PartnerDistributor'],
      },
    ],
  },
  {
    key: 'group-Productions',
    label: 'Sản xuất',
    icon: 'ClipboardCheck',
    tabid: [
      'HygieneSafety',
      'ProductDiary',
      'ProductSupplyChain',
      'ProductionOrder',
      'ProductZone',
    ],
    children: [
      {
        key: ROUTER.AN_TOAN_SAN_XUAT,
        label: 'Quản lý vệ sinh ATCL',
        tabid: ['HygieneSafety'],
      },
      {
        key: ROUTER.NHAT_KY_SAN_PHAM,
        label: 'Nhật ký sản xuất',
        tabid: ['ProductDiary'],
      },
      {
        key: ROUTER.CHUOI_CUNG_UNG,
        label: 'Chuỗi sản xuất',
        tabid: ['ProductSupplyChain'],
      },
      {
        key: ROUTER.DON_SAN_XUAT,
        label: 'Lô sản phẩm',
        tabid: ['ProductionOrder'],
      },
      {
        key: ROUTER.VUNG_SAN_XUAT,
        label: 'Vùng sản xuất',
        tabid: ['ProductZone'],
      },
      // Bổ sung màn quản lý lô sản phẩm
    ],
  },
  {
    key: 'group-Reports',
    label: 'Báo cáo - Thống kê',
    icon: 'BarChart3',
    tabid: [
      'ReportAdminCompany',
      'ReportEnterpriseProduct',
      'ReportAdminQrCode',
      'ProductReportStatistic',
      'ReportEnterpriseProductionOrder',
      'QrCodeRegisterReport',
      'ReportEnterpriseSaleOrder',
      'ReportEnterpriseSupplyDemand',
      'ReportEnterprisePartner',
      'ReportEnterpriseCompany',
    ],
    children: [
      {
        key: ROUTER.BAO_CAO_DOANH_NGHIEP,
        label: 'Báo cáo doanh nghiệp',
        tabid: ['ReportAdminCompany'],
      },
      {
        key: ROUTER.BAO_CAO_SAN_PHAM,
        label: 'Báo cáo sản phẩm',
        tabid: ['ReportEnterpriseProduct'],
      },
      {
        key: ROUTER.THONG_KE_TEM_NHAN,
        label: 'Thống kê tem nhãn',
        tabid: ['ReportAdminQrCode'],
      },
      {
        key: ROUTER.THONG_KE_SAN_PHAM,
        label: 'Thống kê sản phẩm',
        tabid: ['ProductReportStatistic'],
      },
      {
        key: ROUTER.THONG_KE_DON_SAN_XUAT,
        label: 'Thống kê đơn sản xuất',
        tabid: ['ReportEnterpriseProductionOrder'],
      },
      {
        key: ROUTER.THONG_KE_TEM_NHAN_DOANH_NGHIEP,
        label: 'Thống kê tem nhãn (DN)',
        tabid: ['QrCodeRegisterReport'],
      },
      {
        key: ROUTER.THONG_KE_DON_HANG,
        label: 'Thống kê đơn hàng',
        tabid: ['ReportEnterpriseSaleOrder'],
      },
      {
        key: ROUTER.THONG_KE_CUNG_CAU,
        label: 'Thống kê cung cầu',
        tabid: ['ReportEnterpriseSupplyDemand'],
      },
      {
        key: ROUTER.BAO_CAO_DOI_TAC,
        label: 'Báo cáo đối tác',
        tabid: ['ReportEnterprisePartner'],
      },
      {
        key: ROUTER.THONG_KE_DOANH_NGHIEP_DN,
        label: 'Thống kê doanh nghiệp',
        tabid: ['ReportEnterpriseCompany'],
      },
    ],
  },
  {
    key: 'group-Settings',
    label: 'Cài đặt hệ thống',
    icon: 'Settings',
    tabid: ['GeneralSetting', 'AuditLog', 'Menu', 'Employee', 'Role', 'SystemConnect'],
    children: [
      {
        key: ROUTER.CAI_DAT_CHUNG_TIEN_TO,
        label: 'Cài đặt chung',
        tabid: ['GeneralSetting'],
      },
      {
        key: ROUTER.QUAN_LY_NGUOI_DUNG,
        label: 'Quản lý người dùng',
        tabid: ['Employee'],
      },
      {
        key: ROUTER.NHAT_KY_HE_THONG,
        label: 'Nhật ký hệ thống',
        tabid: ['AuditLog'],
      },
      {
        key: ROUTER.QUAN_LY_MENU,
        label: 'Quản lý menu',
        tabid: ['Menu'],
      },
      {
        key: ROUTER.QUAN_LY_PHAN_QUYEN,
        label: 'Nhóm quyền',
        tabid: ['Role'],
      },
      {
        key: ROUTER.THIET_LAP_KET_NOI,
        label: 'Thiết lập kết nối',
        tabid: ['SystemConnect'],
      },
    ],
  },
  {
    key: 'group-Traces',
    label: 'Truy xuất - Tem nhãn',
    icon: 'Tickets',
    tabid: ['QrCode', 'QrCodeRegister'],
    children: [
      {
        key: ROUTER.QUAN_LY_MA_TEM,
        label: 'Quản lý mã/tem',
        tabid: ['QrCode'],
      },
      {
        key: ROUTER.DANG_KY_MA_TEM,
        label: 'Đăng ký mã/tem',
        tabid: ['QrCodeRegister'],
      },
    ],
  },
]

// Không có category "Personal_Information" trong DB goodstrace — bỏ tabid, luôn cho qua
// (hasPermission trả true khi tabid rỗng/undefined)
export const USER_MENU_CONFIG = [
  {
    key: ROUTER.THONG_TIN_TAI_KHOAN,
    label: 'Thông tin cá nhân',
    icon: 'CircleUser',
  },
]
